/*
 * @Author: Nanxing Xiang
 * @Date: 2021-08-20 14:30:29
 * @LastEditors: 向南星 xiangnanxing@scmagic.cn
 * @LastEditTime: 2022-11-25 17:57:58
 * @Description: file content
 */
import { lazy } from 'react';
import createReactRoutes from '@easyvaas/create-react-routes';
import { imagesV3Views } from './modules/imagesV3';

export default createReactRoutes({
  //注册v2路由
  about: lazy(() => import('./modules/about/views')), //关于
  achievements: lazy(() => import('./modules/achievements/views')), //成就中心
  authentication: lazy(() => import('./modules/authentication/views')), //认证
  agreements: lazy(() => import('./modules/agreements/views')), //协议
  collections: lazy(() => import('./modules/collections/views')), //精选收集
  circle: lazy(() => import('./modules/circle/views')),
  civilized_pledge: lazy(() => import('./modules/CivilizedPledge')),
  exchange: lazy(() => import('./modules/exchange/views')), //兑换
  family: lazy(() => import('./modules/family/views')), //家族
  formsv2: lazy(() => import('./modules/formsv2/views')), //表单v2
  help: lazy(() => import('./modules/help/views')),
  imagesV3: imagesV3Views,
  invitation: lazy(() => import('./modules/invitation/views')), //邀请分享赚钱
  level: lazy(() => import('./modules/level')),
  lottery_v3: lazy(() => import('./modules/lotteryV3/views')), //抽奖
  others: lazy(() => import('./modules/others/views')), //其他
  preview: lazy(() => import('./modules/preview/views')), //预览
  quests: lazy(() => import('./modules/quests/views')), //任务中心
  ranks: lazy(() => import('./modules/ranks')), //榜单
  show: lazy(() => import('./modules/show/views')),
  titles: lazy(() => import('./modules/titles/views')), //称额号
  guard: lazy(() => import('./modules/guard')),
  gift_wall: lazy(() => import('src/modules/gift_wall/views')), //礼物墙
  gift_wall_v2: lazy(() => import('src/modules/gift_wall_v2/views')), //礼物墙v2
  glory_wall: lazy(() => import('src/modules/glory_wall/views')), //荣耀典藏
  met: lazy(() => import('src/modules/met/views')), //我遇见的
  vip_v2: lazy(() => import('src/modules/vipV2/views')), //vip中心
  vip_v3: lazy(() => import('src/modules/vipV3/views')),
  watched_v2: lazy(() => import('src/modules/watchedV2/views')), //我看过的
  recharge: lazy(() => import('src/modules/recharge/views')),
  box4d: lazy(() => import('src/modules/box4d/views')),
  //注册v1路由
  '/s/:type': lazy(() => import('src/views/StaticView')),
  '/:appname/password/reset': lazy(() => import('src/views/PasswordReset')),
  '/:appname/agreement/recharge': lazy(
    () => import('src/modules/recharge/views/Agreement')
  ),
  '/gargantua/privacy_policy': lazy(
    () => import('./modules/about/views/PrivacyPolicy/Gargantua')
  ) //关于
});
